import React from "react";
import {useTranslation} from "react-i18next";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/16/solid";
import {cn} from "../utils/style";

function PaginationFull({paginator, get, set}) {
    const {t} = useTranslation()
    const {currentPage, lastPage} = paginator;
    if (currentPage === 1 && lastPage === 1) {
        return <div className="mt-3"></div>
    }

    return (
        <nav className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full mt-10 px-2">
            <div className="flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-gray-400 order-2 sm:order-1">
                <span>{t('pagination.page')}</span>
                <span className="text-[#0b6a8c] font-black">{currentPage}</span>
                <span className="mx-1">/</span>
                <span>{lastPage}</span>
            </div>
            <div className="order-1 sm:order-2">
                <nav aria-label="Pagination" className="isolate inline-flex items-center gap-2">
                        <button
                            disabled={currentPage === 1}
                            onClick={e => {
                                if (currentPage > 1) set(currentPage - 1)
                                else set(1)
                            }}
                            className="relative inline-flex items-center justify-center h-9 w-9 rounded-xl bg-white text-gray-500 border border-gray-200 hover:bg-gray-50 hover:border-cyan-300 hover:text-[#0b6a8c] transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <span className="sr-only">Previous</span>
                            <ChevronLeftIcon aria-hidden="true" className="h-5 w-5"/>
                        </button>

                    <div className="flex items-center gap-1.5">
                        {getPageNumbers(lastPage, currentPage).map((number, index) => (
                            <React.Fragment key={index}>
                                {number === null ? (
                                    <PaginationGap/>
                                ) : (
                                    <PaginationItem paginator={paginator} number={number} set={set}/>
                                )}
                            </React.Fragment>
                        ))}
                    </div>


                    <button
                        disabled={currentPage === lastPage}
                        onClick={e => {
                            if (currentPage < lastPage) set(currentPage + 1)
                            else set(currentPage)
                        }}
                        className="relative inline-flex items-center justify-center h-9 w-9 rounded-xl bg-white text-gray-500 border border-gray-200 hover:bg-gray-50 hover:border-cyan-300 hover:text-[#0b6a8c] transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                            <span className="sr-only">Next</span>
                            <ChevronRightIcon aria-hidden="true" className="h-5 w-5"/>
                        </button>
                </nav>
            </div>
        </nav>
    )
}


function PaginationGap() {
    return <span
        className="relative inline-flex items-center justify-center px-2 text-sm font-bold text-gray-400">
        ...
    </span>;
}

function PaginationItem({number, paginator, set}) {
    const {currentPage} = paginator;
    const isActive = currentPage === number;

    return <button
        onClick={() => set(number)}
        disabled={isActive}
        className={cn(
            "relative cursor-pointer inline-flex items-center justify-center h-9 w-9 text-xs font-bold rounded-xl transition-all duration-200 shadow-sm border",
            isActive
                ? "bg-[#0b6a8c] border-cyan-600 text-white shadow-blue-100"
                : "bg-white border-gray-200 text-gray-600 hover:border-cyan-300 hover:text-[#0b6a8c]"
        )}
    >
        {number}
    </button>
}


function getPageNumbers(totalPages, currentPage) {
    let pageNumbers = [];

    if (totalPages <= 6) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
    } else if (currentPage < 3) {
        pageNumbers = [1, 2, 3, null, totalPages - 2, totalPages - 1, totalPages];
    } else if (currentPage === 3) {
        pageNumbers = [1, 2, 3, 4, null, totalPages - 1, totalPages];
    } else if (currentPage > totalPages - 2) {
        pageNumbers = [1, 2, 3, null, totalPages - 2, totalPages - 1, totalPages];
    } else if (currentPage === totalPages - 2) {
        pageNumbers = [1, 2, null, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
        pageNumbers = [1, null, currentPage - 1, currentPage, currentPage + 1, null, totalPages];
    }

    return pageNumbers;
}

export default PaginationFull;
